<template>
	<div class="card" v-if="result.objectClassName || result.handle || result.startAddress || result.endAddress || result.ipVersion || result.parentHandle">
		<div class="card-header">General Information</div>
		<div class="card-body">
			<table class="table">
				<tbody>
					<tr v-if="result.objectClassName">
						<th scope="row" width="120px">Object</th>
            <td>{{ object_class_labels[result.objectClassName] }} ({{ result.objectClassName }})</td>
					</tr>
					<tr v-if="result.handle">
						<th>Handle</th>
						<td>{{ result.handle }}</td>
					</tr>
					<tr v-if="result.startAddress">
						<th>Start Address</th>
						<td>{{ result.startAddress }}</td>
					</tr>
					<tr v-if="result.endAddress">
						<th>End Address</th>
						<td>{{ result.endAddress }}</td>
					</tr>
					<tr v-if="result.ipVersion">
						<th>IP Version</th>
						<td>{{ result.ipVersion }}</td>
					</tr>
					<tr v-if="result.parentHandle">
						<th>Parent Handle</th>
						<td>{{ result.parentHandle }}</td>
					</tr>
				</tbody>
			</table>
		</div>
  </div>
</template>

<script>
export default {
	props: ['result'],
	data() {
		return {
			object_class_labels: {
				'ip network': 'IP Network',
				entity: 'Entity',
				domain: 'Domain',
				nameserver: 'Nameserver',
				autnum: 'Autonomous System Number'
			}
		};
	}
};
</script>

<style scoped lang="scss">
tbody tr:first-child {
	th,
	td {
		border-top: none;
	}
}
</style>
